import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '@sainsburys-tech/boltui-utils';
import * as Styled from './CarePrice.styles';

var CarePrice = function CarePrice(_ref) {
  var quantity = _ref.quantity,
      price = _ref.price,
      isMonthly = _ref.isMonthly,
      dataTest = _ref.dataTest;
  return /*#__PURE__*/React.createElement(Styled.Wrapper, null, /*#__PURE__*/React.createElement(Styled.Price, {
    "data-test": "".concat(dataTest, "-price")
  }, "+", formatPrice(price)), /*#__PURE__*/React.createElement(Styled.SubPrice, null, isMonthly ? 'per month' : 'one-off payment'), quantity > 1 && /*#__PURE__*/React.createElement(Styled.SubPrice, null, isMonthly ? 'per item' : 'each'));
};

CarePrice.propTypes = {
  quantity: PropTypes.number,
  price: PropTypes.number,
  dataTest: PropTypes.string
};
export default CarePrice;